// Holding a Web Lock is one of the signals browsers use to keep a background tab from being
// put to sleep (Microsoft's documented workaround for SignalR in sleeping tabs). The lock is
// shared, so any number of tabs can hold it at once. Returns the function that releases it.

const LOCK_NAME = "oxygen-realtime-keep-awake";

export const holdTabAwake = () => {
  if (!navigator.locks?.request) return () => {};

  let release;
  const held = new Promise((resolve) => { release = resolve; });
  navigator.locks.request(LOCK_NAME, { mode: "shared" }, () => held).catch((error) => {
    console.warn("[Realtime] Could not hold the keep-awake lock:", error);
  });
  return release;
};
